<template>
	<div class="flex min-h-screen flex-col bg-gray-100">
		<Anouncement
			v-if="announcements.length"
			:key="announcements.length"
			class="h-[50px] w-full"
			:announcements="announcements"
			@closed="handleCloseAnnouncement"
		/>

		<div class="flex flex-1 items-center justify-center p-4 sm:p-8">
			<div class="flex w-full max-w-4xl overflow-hidden rounded-2xl shadow-lg">
				<AuthBrandingPanel :partner="partnerStore.partner" />
				<div class="flex-1 basis-1/2 bg-white">
					<slot />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

import Anouncement from '../components/anouncement';
import AuthBrandingPanel from '../components/auth-branding-panel.vue';
import { getAnnouncements } from '../api/announcements';
import { usePartnerStore } from '../store/partner.store';
import { getStorageJson } from '../utils/helpers';

const route = useRoute();
const partnerStore = usePartnerStore();

const announcements = ref([]);

const closedAnnouncements = getStorageJson('closedAnnouncements');

const handleCloseAnnouncement = (uuid) => {
	announcements.value = announcements.value.filter((el) => uuid !== el.uuid);
};

const syncPartner = () => {
	if (route.params.slug) {
		partnerStore.fetchPartner(route.params.slug);
	}
};

onMounted(() => {
	getAnnouncements()
		.then((data) => {
			const list = Array.isArray(data) ? data : [];
			announcements.value = list.filter((el) => !closedAnnouncements.includes(el.uuid));
		})
		.catch(() => { announcements.value = []; });

	syncPartner();
});

watch(() => route.params.slug, syncPartner);
</script>
